export default __webpack_public_path__ + "static/media/img-1.68cb2ec2.jpg";